module.exports = __webpack_public_path__ + "static/profile-image-5-5aa3ebc8e0634024a5dbffe91cc69cbf.jpeg";